import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private currentVersion: string | null = null;

  async initialize(): Promise<void> {
    await this.unregisterLegacyServiceWorkers();
    this.currentVersion = await this.fetchVersion();
  }

  async checkForUpdate(): Promise<boolean> {
    const latest = await this.fetchVersion();
    if (!latest || !this.currentVersion) {
      return false;
    }
    return latest !== this.currentVersion;
  }

  private async fetchVersion(): Promise<string | null> {
    try {
      const response = await fetch('/index.html', { cache: 'no-store' });
      if (!response.ok) {
        return null;
      }
      const html = await response.text();
      const match = html.match(/main-[A-Z0-9]+\.js/i);
      return match ? match[0] : null;
    } catch {
      return null;
    }
  }

  private async unregisterLegacyServiceWorkers(): Promise<void> {
    if (!('serviceWorker' in navigator)) {
      return;
    }
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((r) => r.unregister()));
    } catch {
      // ignore — best-effort cleanup
    }
  }
}
